import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom, Observable } from 'rxjs';
import config from '../../../config';
import { IStartOver } from '../models/game.model';

@Injectable({
  providedIn: 'root',
})
export class GameService {
  baseUrl = config.API_GATEWAY_ENDPOINT;

  constructor(private http: HttpClient) {}

  startOver(prid: string, scenarioId: string): Promise<IStartOver> {
    const res = lastValueFrom(
      this.http.delete<IStartOver>(
        `${this.baseUrl}/user/${prid}/${scenarioId}`,
        {}
      )
    );

    return res;
  }
}
